if (!customElements.get('hero-social-proof-quotes')) {
  class HeroSocialProofQuotes extends HTMLElement {
    connectedCallback() {
      this.quotes = Array.from(this.querySelectorAll('.hero-social-proof__testimonial-quote'));
      if (this.quotes.length < 2) return;

      this.activeIndex = this.quotes.findIndex((quote) => quote.classList.contains('is-active'));
      if (this.activeIndex === -1) {
        this.activeIndex = 0;
        this.quotes[0].classList.add('is-active');
      }

      this.interval = Number(this.dataset.interval) || 5000;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.addEventListener('mouseenter', this.stop.bind(this));
      this.addEventListener('mouseleave', this.start.bind(this));
      this.addEventListener('focusin', this.stop.bind(this));
      this.addEventListener('focusout', this.start.bind(this));
      document.addEventListener('visibilitychange', () => {
        document.hidden ? this.stop() : this.start();
      });

      this.start();
    }

    start() {
      if (this.reducedMotion || this.timer || document.hidden) return;
      this.timer = setInterval(this.next.bind(this), this.interval);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    next() {
      this.quotes[this.activeIndex].classList.remove('is-active');
      this.activeIndex = (this.activeIndex + 1) % this.quotes.length;
      this.quotes[this.activeIndex].classList.add('is-active');
    }
  }

  customElements.define('hero-social-proof-quotes', HeroSocialProofQuotes);
}

document.querySelectorAll('.hero-social-proof__text-link').forEach((link) => {
  link.addEventListener('click', (event) => {
    const hash = link.getAttribute('href');
    if (!hash || !hash.startsWith('#')) return;

    const target = document.querySelector(hash);
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth' });
    history.pushState(null, '', hash);
  });
});
